import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Collapsed Advanced disclosure — plan/13, plan/34. Same in Everyday & Power. */
export function AdvancedSection(props: {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
  defaultOpen?: boolean;
}) {
  const label = props.subtitle
    ? `${props.title ?? "Advanced"} · ${props.subtitle}`
    : (props.title ?? "Advanced");

  return (
    <details
      className={cn(
        "group mt-6 rounded-[var(--radius-xl)] border border-[var(--color-border)]/90 bg-[var(--color-card)]/55 open:bg-[var(--color-card)]",
        props.className,
      )}
      {...(props.defaultOpen ? { defaultOpen: true } : {})}
    >
      <summary className="cursor-pointer list-none px-4 py-3 text-sm font-medium text-[var(--color-foreground)] marker:content-none [&::-webkit-details-marker]:hidden">
        <span className="inline-flex items-center gap-2">
          <span
            aria-hidden
            className="text-[var(--color-muted-fg)] transition-transform group-open:rotate-90"
          >
            ▸
          </span>
          {label}
        </span>
      </summary>
      <div className="space-y-4 border-t border-[var(--color-border)]/90 px-4 py-4">
        {props.children}
      </div>
    </details>
  );
}
